import {
  DispatchSummaryCallVolumeEnum,
  DispatchSummaryChatVolumeEnum,
  DispatchSummaryDispatcherAssetCamerasWorkingEnum,
  DispatchSummaryDispatcherShiftEnum,
  DispatchSummaryDispatcherWasThereEightByEightIssueEnum,
  DispatchSummaryMarket,
  DispatchSummaryWithCache,
} from '@/models/gen/graphql';
import { clearFormStorage, getFormStorage, setFormStorage } from '@/common/Form';

import { Schema } from '@/utils';

export namespace SummaryHistoryFormDefinitions {
  export type Locale =
    | 'SUBMIT_BUTTON_TEXT'
    | 'SUBMIT_BUTTON_COLOR'
    | 'Dispatch Summary'
    | 'Call Volume'
    | 'Chat Volume'
    | 'Nominal - under 10 calls per hour'
    | 'Low - under 50 calls per hour'
    | 'Medium - 50-100 calls per hour'
    | 'High - over 100 calls per hour'
    | 'Low - 20 chats per hour'
    | 'Medium - 50 chats per hour'
    | 'High - 75+ chats per hour'
    | 'Create Dispatch Summary'
    | 'Dispatcher'
    | 'Your Shift'
    | 'Overview Of The Day'
    | 'Passdown Completed? By Whom?'
    | 'Was There An 8X8 Issue Today?'
    | 'Was There An 8X8 Issue Today? Explain'
    | 'Were All Samsara Cameras Working In All Stations?'
    | 'List Stations And Van Numbers Not Working'
    | 'Any Issues With New Software? Please Explain'
    | 'Service Issues By Station'
    | 'Van Issues By Station'
    | 'Station'
    | 'Comments And Changes By City'
    | 'Add City'
    | 'Taxis/Lyft By Station'
    | 'Training Issues By Class'
    | 'Driving Issues By Station'
    | 'Detailed Explanation'
    | 'Must not exceed 512 characters'
    | 'Must not exceed 16 characters'
    | 'Repeat speeding offenders: (Events 10MPH over limit)'
    | 'Repeat offenders For distracted driving:';
  export type Value = Partial<DispatchSummaryWithMarketComments>;
  export type Props = {
    onSubmit?: (data: Value) => void | Value | Promise<Value> | undefined;
    locale?: Partial<Record<Locale, string>>;
    value?: Value;
  };
  export const initValue: Value = {
    id: '',
    callVolume: null,
    dispatcherId: '',
    dispatcherShift: null,
    dispatcherDayOverview: '',
    dispatcherPassdown: '',
    dispatcherEightByEightIssue: '',
    dispatcherAssetCamerasWorking: null,
    dispatcherAssetCamerasWorkingNotes: '',
    dispatcherSoftwareIssues: '',
    dispatcherServiceIssues: '',
    dispatcherStationVansIssues: '',
    manifestsTaxis: '',
    manifestsTrainingIssues: '',
    manifestsDrivingIssues: '',
    marketComments: [],
    marketCommentsForm: {},
    commentsRepeatDistractedOffenders: '',
    commentsRepeatSpeedingOffenders: '',
    dispatcherWasThereEightByEightIssue: null,
    chatVolume: null,
  };
  export const getLocale = (value: Partial<Value>): Partial<Record<Locale, string>> => ({
    SUBMIT_BUTTON_TEXT: value.id ? 'Save Summary' : 'Create Summary',
    SUBMIT_BUTTON_COLOR: value.id ? 'primary' : 'success',
  });

  export const validator = (locale: (original: Locale) => string) =>
    Schema((z) =>
      z.object({
        id: z.string().uuid(),
        callVolume: z.nativeEnum(DispatchSummaryCallVolumeEnum, { message: 'Required' }),
        chatVolume: z.nativeEnum(DispatchSummaryChatVolumeEnum, { message: 'Required' }),
        dispatcherId: z.string().uuid({ message: 'Required' }),
        dispatcherShift: z.nativeEnum(DispatchSummaryDispatcherShiftEnum, { message: 'Required' }),
        dispatcherDayOverview: z.string().nonempty('Required'),
        dispatcherPassdown: z.string().nonempty('Required'),
        dispatcherWasThereEightByEightIssue: z.nativeEnum(DispatchSummaryDispatcherWasThereEightByEightIssueEnum, { message: 'Required' }),
        dispatcherEightByEightIssue: z.string().nonempty('Required'),
        dispatcherAssetCamerasWorking: z.nativeEnum(DispatchSummaryDispatcherAssetCamerasWorkingEnum, {
          message: 'Required',
        }),
        dispatcherAssetCamerasWorkingNotes: z.string().nonempty('Required'),
        dispatcherSoftwareIssues: z.string().nonempty('Required'),
        dispatcherServiceIssues: z.string().nonempty('Required'),
        dispatcherStationVansIssues: z.string().nonempty('Required'),
        manifestsTaxis: z.string().nonempty('Required'),
        manifestsTrainingIssues: z.string().nonempty('Required'),
        manifestsDrivingIssues: z.string().min(1, { message: 'Required' }),
        marketCommentsForm: z.record(z.string().nonempty('Required')).default({}),
        commentsRepeatDistractedOffenders: z.string().min(1, { message: 'Required' }),
        commentsRepeatSpeedingOffenders: z.string().min(1, { message: 'Required' }),
      })
    );
  export const searchable = {
    createdAt: (val) => val,
    dispatcherFirstName: (val, full) => [val, full?.dispatcherLastName || ''].join(' ').trim(),
    dispatcherShift: (val) => val,
    callVolume: (val) => val,
  };
  export const saveForm = (values: Value): void => setFormStorage('SummaryHistoryDrawer', values);
  export const loadForm = (): Value => getFormStorage('SummaryHistoryDrawer');
  export const clearForm = (): void => clearFormStorage('SummaryHistoryDrawer');
}
// SearchDispatchSummary Service
export type DispatchSummaryWithMarketComments = DispatchSummaryWithCache & {
  marketComments: DispatchSummaryMarket[];
  marketCommentsForm: Record<string, string>;
};
